<script setup>
  import { reactive, ref } from 'vue'

  import { useAuthStore } from '@/features/auth/useAuthStore.js'
  import LayoutUserProfileDropdown from '@/features/layout/components/userProfile/LayoutUserProfileDropdown.vue'
  import { vOnClickOutside } from '@/features/ui/directives/onClickOutside.js'

  const authStore = useAuthStore()
  const showDropdown = ref(false)

  function toggleDropdown() {
    showDropdown.value = !showDropdown.value
  }

  function closeDropdown() {
    showDropdown.value = false
  }

  const dropdownClasses = reactive({
    show: showDropdown,
  })
</script>

<template>
  <div v-on-click-outside="closeDropdown" class="avatar-menu-wrapper">
    <button
      class="avatar-menu-image"
      type="button"
      aria-label="User Profile Menu"
      @click="toggleDropdown"
    >
      <img :src="authStore.avatarUrl" alt="Avatar" />
    </button>

    <div class="avatar-menu-dropdown" :class="dropdownClasses">
      <LayoutUserProfileDropdown v-if="showDropdown" />
    </div>
  </div>
</template>

<style lang="scss" scoped>
  .avatar-menu-wrapper {
    position: relative;
    height: 100%;
    display: flex;
    align-items: center;
  }

  .avatar-menu-image {
    @include resetButton;
    @include focusRing;

    height: 48px;
    width: 48px;
    border-radius: 24px;
    border: 1px solid light-dark(#fff, #000);
    cursor: pointer;

    img {
      height: 100%;
      width: 100%;
      border-radius: 24px;
    }
  }

  .avatar-menu-dropdown {
    position: absolute;
    width: 320px;
    right: 0;
    z-index: 110;
    top: calc(100% + 2px);
    padding: 20px;
    gap: 40px;
    border-bottom-left-radius: 8px;
    border-bottom-right-radius: 8px;
    box-shadow: 0 4px 62px 0 #0000001f;
    background: light-dark(#fff, #121212);
    opacity: 0;
    transition: opacity 0.3s;
    will-change: opacity;
    color: var(--fm-ui-primary-color);
    visibility: hidden;
  }

  .show {
    opacity: 1;
    visibility: visible;
  }
</style>
